import { render } from "./DefaultButton.vue?vue&type=template&id=7cc427e6"
import script from "./DefaultButton.vue?vue&type=script&lang=js"
export * from "./DefaultButton.vue?vue&type=script&lang=js"

import "./DefaultButton.vue?vue&type=style&index=0&id=7cc427e6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__